export default {"src":"/_next/static/media/Shaghayegh.d7954fef.svg","height":237,"width":978,"blurWidth":0,"blurHeight":0};